import styled from 'styled-components'

export const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
`
export const PopularTopics = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

export const PopularTopicsList = styled.div`
  margin-left: -0.5rem;
  margin-right: -0.5rem;
`

export const PostTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const BlogSearchWrapper = styled.div`
  width: 80%;
`
